

import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import Select from '../components/Select';
//import datas from "./agences_temp.json";

const Map = {
    init: function () {

        Map.html = document.querySelector("html");

        const globes = document.querySelectorAll(".f-map");

        globes.forEach(globe => {

            globe.url = globe.dataset.api;

            if (!globe.url) {
                return false;
            }

            fetch(globe.url)
                .then(response => response.json())
                .then(datas => {
                    datas = Map.transformJSON(datas);
                    globe.dataSource = datas;

                    globe.datas = {
                        "currentcapability": "0",
                        "currentregion": "0",
                        "region": [],
                        "countries": [],
                        "capabilities": []
                    }

                    globe.RAYON = 2;

                    globe.intro = globe.querySelector(".f-map__intro");
                    globe.listePays = globe.querySelector(".f-map__countryBox");
                    globe.stats = globe.querySelector(".f-map__statsListe");

                    globe.zoomReset = globe.querySelector(".f-map__zoomReset");
                    globe.zoomMore = globe.querySelector(".f-map__zoomMore");
                    globe.zoomLess = globe.querySelector(".f-map__zoomLess");

                    Map.initInterface(globe, datas);

                    globe.canvas = document.querySelector(".f-map__canvas");;

                    const scene = new THREE.Scene();
                    const camera = new THREE.PerspectiveCamera(75, 1, 0.1, 1000);
                    globe.camera = camera;

                    const renderer = new THREE.WebGLRenderer({
                        alpha: true,
                        antialias: true
                    });

                    let heightGlobal = window.innerHeight;
                    heightGlobal = heightGlobal < 700 ? 700 : heightGlobal;

                    renderer.setSize(heightGlobal * 0.9, heightGlobal * 0.9);
                    renderer.setPixelRatio(2);
                    window.addEventListener('resize', () => {
                        //Map.resizeMap(globe);
                        let heightGlobal = window.innerHeight;
                        heightGlobal = heightGlobal < 700 ? 700 : heightGlobal;
                        renderer.setSize(heightGlobal * 0.9, heightGlobal * 0.9);
                    }, false);

                    let userInteracted = false;
                    let userInteractedTimeout = 0;
                    const controls = new OrbitControls(camera, renderer.domElement);
                    controls.enableZoom = false;
                    controls.enablePan = false;
                    controls.enableDamping = true;
                    controls.dampingFactor = 0.05;
                    controls.autoRotate = true;
                    controls.autoRotateSpeed = -2;


                    globe.canvas.addEventListener('mousedown', () => {
                        userInteracted = true;

                        clearTimeout(userInteractedTimeout);
                        userInteractedTimeout = setTimeout(() => {
                            userInteracted = false;
                        }, 20000)
                    });

                    // Charge la texture
                    const textureLoader = new THREE.TextureLoader();
                    const texture = textureLoader.load('/wp-content/themes/hadvisors/dist/assets/img/world-map.png');
                    const geometry = new THREE.SphereGeometry(globe.RAYON, 64, 64);
                    const material = new THREE.MeshPhongMaterial({ map: texture });

                    // Crée le groupe 
                    const group = new THREE.Group();

                    // Crée le mesh
                    const sphere = new THREE.Mesh(geometry, material);
                    group.add(sphere);

                    // Éclairage
                    const ambientLight = new THREE.AmbientLight(0xffffff, 0.1); // lumière blanche douce
                    scene.add(ambientLight);

                    const directionLight = new THREE.SpotLight(0x4488ff, 8);
                    scene.add(directionLight);
                    directionLight.position.set(...camera.position);

                    // Position de la caméra
                    camera.position.z = 3.6;

                    let zoomAnimation = null;

                    globe.zoomMore.addEventListener("click", () => {
                        if (zoomAnimation) return;
                        zoomAnimation = {
                            direction: 'in',
                            startDistance: camera.position.distanceTo(controls.target),
                            targetDistance: Math.max(camera.position.distanceTo(controls.target) - 0.4, 2.4),
                            speed: 0.2
                        };
                    });

                    globe.zoomLess.addEventListener("click", () => {
                        if (zoomAnimation) return;
                        zoomAnimation = {
                            direction: 'out',
                            startDistance: camera.position.distanceTo(controls.target),
                            targetDistance: Math.min(camera.position.distanceTo(controls.target) + 0.4, 5),
                            speed: 0.2
                        };
                    });

                    globe.zoomReset.addEventListener("click", () => {
                        if (zoomAnimation) return;
                        zoomAnimation = {
                            direction: 'reset',
                            startDistance: camera.position.distanceTo(controls.target),
                            targetDistance: 3.6,
                            speed: 0.2
                        };
                    });

                    //Rajout des points de pays
                    globe.pinCountries = {};
                    datas.country.forEach(country => {
                        let material = new THREE.SpriteMaterial({ map: Map.genereCanvas(2) });
                        let sprite = new THREE.Sprite(material);
                        globe.pinCountries[country.name.toLowerCase()] = sprite;
                        sprite.country = country.name;
                        sprite.position.set(...Map.lngLatToXYZ(country.lng, country.lat, globe.RAYON + 0.03));
                        sprite.scale.set(0.1, 0.1, 0.1);
                        sprite.lookAt(2 * sprite.position.x, 2 * sprite.position.y, 2 * sprite.position.z)
                        group.add(sprite);
                    })

                    scene.add(group);

                    const raycaster = new THREE.Raycaster();
                    const mouse = new THREE.Vector2();

                    function onMouseMove(event) {
                        if (true || globe.datas.currentregion !== "0" || globe.datas.currentcapability !== "0") {
                            const rect = renderer.domElement.getBoundingClientRect();
                            mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                            mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

                            raycaster.setFromCamera(mouse, camera);

                            const intersects = raycaster.intersectObjects(scene.children, true);

                            let sprite;

                            if (intersects.length > 0 && intersects[0].object?.type === "Sprite") {
                                sprite = intersects[0].object;
                                let country = sprite.country;
                                if (country) {
                                    sprite.isOver = true;
                                    Map.renderPin(globe, sprite);
                                }
                                Map.html.style.cursor = "pointer";
                            } else {
                                Map.html.style.cursor = "default";
                            }

                            for (let key in globe.pinCountries) {
                                let pin = globe.pinCountries[key];
                                if (pin != sprite && pin.isOver) {
                                    pin.isOver = false;
                                    Map.renderPin(globe, pin);
                                }
                            }
                        }
                    }

                    function onMouseClick(event) {
                        if (true || globe.datas.currentregion !== "0" || globe.datas.currentcapability !== "0") {
                            const rect = renderer.domElement.getBoundingClientRect();
                            mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                            mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

                            raycaster.setFromCamera(mouse, camera);

                            const intersects = raycaster.intersectObjects(scene.children, true);

                            console.log("INTERSECT", intersects)

                            let sprite;

                            if (intersects.length > 0 && intersects[0].object?.type === "Sprite") {
                                sprite = intersects[0].object;

                                if (sprite.agenceLink) {
                                    document.location.href = sprite.agenceLink;
                                } else {
                                    let country = sprite.country;
                                    if (country) {
                                        sprite.isSelected = !sprite.isSelected;
                                        Map.renderPin(globe, sprite);

                                        if (globe.datas.currentregion === "0" || globe.datas.currentcapability === "0") {
                                            let thisRegion = Map.getRegion(globe, sprite.country);
                                            globe.datas.currentregion = thisRegion;
                                            Map.renderInterface(globe);
                                        }
                                    }

                                    for (let key in globe.pinCountries) {
                                        let pin = globe.pinCountries[key];
                                        if (pin != sprite && pin.isSelected) {
                                            pin.isSelected = false;
                                            Map.renderPin(globe, pin);
                                        }
                                    }
                                }
                            }
                        }
                    }

                    renderer.domElement.addEventListener('mousemove', onMouseMove);
                    renderer.domElement.addEventListener('click', onMouseClick);


                    // Ajoute le canvas du renderer au conteneur de la carte
                    globe.canvas.appendChild(renderer.domElement);

                    // Rend la scène
                    renderer.render(scene, camera);

                    function animate() {
                        requestAnimationFrame(animate);
                        if (globe.canvas.getBoundingClientRect().width !== 0) {


                            if (globe.datas.currentregion !== "0" && globe.newPosition && !isNaN(globe.newPosition.lng) && !isNaN(globe.newPosition.lat) && !globe.newPositionDone) {
                                // Convertir la nouvelle position de lat/lng en coordonnées 3D

                                globe.currentLngLat = Map.xyzToLngLat(...camera.position);

                                globe.currentLngLat[0] = globe.currentLngLat[0] * 0.92 + globe.newPosition.lng * 0.08;
                                globe.currentLngLat[1] = globe.currentLngLat[1] * 0.92 + globe.newPosition.lat * 0.08;

                                if (Math.abs(globe.currentLngLat[0] - globe.newPosition.lng) < 0.05
                                    && Math.abs(globe.currentLngLat[1] - globe.newPosition.lat) < 0.05
                                ) {
                                    globe.newPositionDone = true;
                                    globe.currentLngLat[0] = globe.newPosition.lng;
                                    globe.currentLngLat[1] = globe.newPosition.lat;
                                }

                                let targetPos = Map.lngLatToXYZ(globe.currentLngLat[0], globe.currentLngLat[1], camera.position.distanceTo(controls.target));
                                camera.position.set(...targetPos);
                            }

                            if (!userInteracted && globe.datas.currentregion === "0" && globe.datas.currentcapability === "0") {
                                controls.autoRotateSpeed = -2;
                            } else {
                                controls.autoRotateSpeed = 0.0001;
                            }

                            // Gestion du zoom (sans modification pour correspondre à votre demande)
                            if (zoomAnimation) {
                                const currentDistance = camera.position.distanceTo(controls.target);
                                const newDistance = currentDistance + (zoomAnimation.targetDistance - currentDistance) * zoomAnimation.speed;

                                const directionVector = camera.position.clone().sub(controls.target).normalize();
                                camera.position.copy(controls.target).add(directionVector.multiplyScalar(newDistance));
                                controls.update();

                                if (Math.abs(newDistance - zoomAnimation.targetDistance) < 0.01) {
                                    zoomAnimation = null;
                                }
                            }

                            controls.update();

                            directionLight.position.set(...camera.position);

                            renderer.render(scene, camera);
                        }
                    }
                    animate();

                    let anchor = document.location.hash.split("#").join();

                    globe.datas.region.forEach(reg => {
                        if (anchor.indexOf(reg.toLowerCase()) > -1) {
                            globe.datas.currentregion = reg.toLowerCase();
                        }
                    })

                    console.log(globe.datas.currentregion);

                    Map.renderInterface(globe);

                    Map.resizeMap(globe);
                })
        })
    },

    resizeMap(globe) {
        globe.style.height = "";
        globe.style.height = globe.getBoundingClientRect().height + "px";
    },

    initInterface(globe, datas) {


        datas.agences.forEach(agence => {
            //Enregistrement des regions du JSON dans le data
            if (globe.datas.region.indexOf(agence.region) === -1) {
                globe.datas.region.push(agence.region);
            }

            //Enregistrement des capabilities du JSON dans le data
            agence.capabilities.forEach(cap => {
                if (globe.datas.capabilities.indexOf(cap) === -1) {
                    globe.datas.capabilities.push(cap);
                }
            })
        })

        //Generation du dom des Regions
        globe.buttonBox = globe.querySelector(".f-map__buttonBox");

        if (globe.datas.region.length > 0) {

            globe.datas.region.sort((a, b) => a < b ? -1 : 1);

            let temp = '<ul class="f-map__buttonList">';

            globe.datas.region.forEach(region => {
                temp += `<li class="f-map__buttonItem"><button data-region="${region.toLowerCase()}">${region}</button></li>`
            })
            temp += '</ul>';

            globe.buttonBox.innerHTML = temp;
        }

        globe.buttonsRegion = [...globe.querySelectorAll(".f-map__buttonItem button")];
        globe.buttonsRegion.forEach(btn => {
            btn.addEventListener("click", () => {
                globe.datas.currentregion = (globe.datas.currentregion === btn.dataset.region ? "0" : btn.dataset.region);
                Map.renderInterface(globe);
            });
        });

        //Generation du dom des Capabilities
        globe.selectCapability = globe.querySelector(".f-map__select");
        let choices = [];
        globe.datas.capabilities.sort((a, b) => a > b ? 1 : -1).forEach(cap => {
            cap = cap.split("&amp;").join("&");
            globe.selectCapability.innerHTML += `<option value="${cap}">${cap}</option>`;
            choices.push({
                label: cap,
                value: cap,
                disabled: false
            })
        })

        globe.selectCapability.addEventListener("change", () => {
            globe.datas.currentcapability = (globe.selectCapability.value === "" ? "0" : globe.selectCapability.value);
            Map.renderInterface(globe);
        })

        Select.init(true, choices, globe.selectCapability);

        globe.listePays.addEventListener("click", (e) => {
            if (e.target.tagName === "BUTTON") {
                let buttons = globe.querySelectorAll(".f-map__countryBox button");

                buttons.forEach(btn => {
                    let country = btn.parentElement.dataset.id;
                    if (btn === e.target && btn.parentElement.classList.contains("f-map__countryItem--close")) {
                        //btn.parentElement.classList.remove("f-map__countryItem--close")
                        globe.pinCountries[country].isSelected = true;
                    } else {
                        //btn.parentElement.classList.add("f-map__countryItem--close")
                        globe.pinCountries[country].isSelected = false;
                    }
                    Map.renderPin(globe, globe.pinCountries[country]);
                });
            }
        })

        globe.listePays.addEventListener("mouseover", (e) => {
            if (e.target.tagName === "BUTTON") {
                let country = e.target.parentElement.dataset.id;
                globe.pinCountries[country].isOver = true;
                Map.renderPin(globe, globe.pinCountries[country]);
            }
        })

        globe.listePays.addEventListener("mouseout", (e) => {
            if (e.target.tagName === "BUTTON") {
                let country = e.target.parentElement.dataset.id;
                globe.pinCountries[country].isOver = false;
                Map.renderPin(globe, globe.pinCountries[country]);
            }
        })
    },

    renderPin(globe, pin) {
        pin.material.map = Map.genereCanvas(pin.nb, pin.isOver || pin.isSelected);
        pin.material.needsUpdate = true;

        let buttons = globe.querySelectorAll(".f-map__countryBox button");
        buttons.forEach(btn => {
            let country = btn.parentElement.dataset.id;
            if (globe.pinCountries[country].isSelected) {
                btn.parentElement.classList.remove("f-map__countryItem--close")
            } else {
                btn.parentElement.classList.add("f-map__countryItem--close")
            }
        });

        if (!pin.subpin) {
            pin.subpin = [];
        }

        // OLD LOGIC
        // if (pin.isSelected) {

        //     let agencies = [];

        //     for (let i = 0; i < globe.datas.countries.length; i++) {
        //         if (globe.datas.countries[i].name === pin.country) {
        //             agencies = globe.datas.countries[i].agences;
        //         }
        //     }

        //     if (agencies.length > 0) {
        //         agencies.forEach((agence, index) => {
        //             let [texture, ratio] = Map.genereCanvasSubpin(agence.name);
        //             let material = new THREE.SpriteMaterial({ map: texture });
        //             let sprite = new THREE.Sprite(material);
        //             let link_url = agence.link;
        //             //if (agencies.length > 1) link_url = '../redirect/?c=' + agence.country;
        //             sprite.agenceLink = link_url;

        //             sprite.scale.set(ratio, 1, 1);
        //             sprite.center.set(0, 0);
        //             sprite.position.set(0, index * 1.5, 0.5);
        //             pin.subpin.push(sprite);
        //             pin.add(sprite);
        //         })
        //     }

        if (pin.isSelected) {
            let agencies = [];
            for (let i = 0; i < globe.datas.countries.length; i++) {
                if (globe.datas.countries[i].name === pin.country) {
                    agencies = globe.datas.countries[i].agences;
                }
            }

            if (agencies.length > 0) {
                // --- NEW LOGIC: Extract unique cities for the floating sprites ---
                const uniqueCities = new Set();
                agencies.forEach(a => {
                    if (a.cities) a.cities.split(",").forEach(c => uniqueCities.add(c.trim()));
                });

                const sortedCities = Array.from(uniqueCities).sort();

                sortedCities.forEach((cityName, index) => {
                    let [texture, ratio] = Map.genereCanvasSubpin(cityName);
                    let material = new THREE.SpriteMaterial({ map: texture });
                    let sprite = new THREE.Sprite(material);

                    // Find the link for the first agency associated with this city
                    let agenceInCity = agencies.find(a => a.cities && a.cities.includes(cityName));
                    sprite.agenceLink = agenceInCity ? agenceInCity.link : '#';

                    sprite.scale.set(ratio, 1, 1);
                    sprite.center.set(0, 0);
                    sprite.position.set(0, index * 1.5, 0.5); // Stack them vertically
                    pin.subpin.push(sprite);
                    pin.add(sprite);
                });
            }

        } else if (!pin.isSelected) {
            pin.clear();
            pin.subpin = [];
        }
    },

    renderInterface(globe) {
        //Partie Visuel Region
        globe.buttonsRegion.forEach(btn => btn.parentElement.classList.remove("f-map__buttonItem--active"));
        globe.buttonsRegion.filter(btn => btn.dataset.region === globe.datas.currentregion)[0]?.parentElement?.classList?.add("f-map__buttonItem--active");

        let currentAgences = globe.dataSource.agences.filter(agence => {
            return (
                (globe.datas.currentregion === "0" || agence.region.toLowerCase() === globe.datas.currentregion)
                && (globe.datas.currentcapability === "0" || agence.capabilities.indexOf(globe.datas.currentcapability) > -1)
            )
        });

        globe.datas.countries = [];
        currentAgences.forEach(agence => {
            let country = globe.datas.countries.filter(country => country.name === agence.country);
            if (country.length === 0) {
                let lnglat = globe.dataSource.country.filter(c => c.name.toLowerCase() === agence.country.toLowerCase())[0];
                globe.datas.countries.push({ "name": agence.country, "link": agence.link, "region": agence.region, "agences": [], "lng": lnglat.lng, "lat": lnglat.lat });
            }
            country = globe.datas.countries.filter(country => country.name === agence.country)[0];
            country.agences.push({ "name": agence.name, "link": agence.link, "country": agence.country, "cities": agence.city.join(", ") });
        })

        // OLD LOGIC
        // for (let key in globe.pinCountries) {
        //     let result = globe.datas.countries.filter(country => country.name.toLowerCase() === key.toLowerCase());
        //     if (result.length > 0) {
        //         globe.pinCountries[key].visible = true;
        //         globe.pinCountries[key].nb = result[0].agences.length;
        //         globe.pinCountries[key].material.map = Map.genereCanvas(globe.pinCountries[key].nb > 1 ? globe.pinCountries[key].nb : "");
        //         globe.pinCountries[key].material.needsUpdate = true;

        //     } else {
        //         globe.pinCountries[key].visible = false;
        //     }
        // }

        for (let key in globe.pinCountries) {
            let result = globe.datas.countries.filter(country => country.name.toLowerCase() === key.toLowerCase());
            if (result.length > 0) {
                // --- NEW LOGIC: Count unique cities instead of agencies ---
                const countryObj = result[0];
                const citySet = new Set();
                countryObj.agences.forEach(a => {
                    if (a.cities) {
                        a.cities.split(",").forEach(c => citySet.add(c.trim()));
                    }
                });

                globe.pinCountries[key].visible = true;
                // Set the bubble number to the size of the unique cities set
                globe.pinCountries[key].nb = citySet.size;

                // Update the canvas (only show number if > 1)
                globe.pinCountries[key].material.map = Map.genereCanvas(globe.pinCountries[key].nb > 1 ? globe.pinCountries[key].nb : "");
                globe.pinCountries[key].material.needsUpdate = true;
            } else {
                globe.pinCountries[key].visible = false;
            }
        }

        globe.newPositionDone = false;
        globe.newPosition = Map.getCenterPosition(globe.datas.countries);

        globe.listePays.innerHTML = "";

        if (globe.datas.countries.length > 0) {
            globe.datas.countries.sort((a, b) => a.name < b.name ? -1 : 1);

            let temp = '<ul class="f-map__countryListe">';
            let link_url = '';

            globe.datas.countries.forEach((country, index) => {
                temp += `<li class="f-map__countryItem f-map__countryItem--close" data-id="${country.name.toLowerCase()}">`;
                temp += `<button>${country.name}</button><span class="icon-arrow-down"></span>`;

                temp += `<div class="f-map__countryDetail">`;
                temp += `<div class="f-map__countryInner">`;

                // Create a Set to store unique city names
                // new Set(): A special JavaScript object that only allows unique values.
                const uniqueCities = new Set();

                // First pass: Collect and clean all city names from all agencies
                country.agences.forEach(agence => {
                    if (agence.cities) {
                        // Split string by comma, loop through, trim spaces, and add to Set
                        agence.cities.split(",").forEach(city => {
                            uniqueCities.add(city.trim());
                        });
                    }
                });

                // Convert Set to Array and Sort
                const sortedCitiesArray = Array.from(uniqueCities).sort((a, b) => a.localeCompare(b));
                //console.log(sortedCitiesArray, 'uniqueCities');

                // Second pass: Loop over the UNIQUE cities 
                sortedCitiesArray.forEach(city => {
                    // We find the first agency that contains this city to get a valid link
                    const agenceInCity = country.agences.find(a => a.cities && a.cities.includes(city));
                    const link_url = agenceInCity ? agenceInCity.link : "#";

                    temp += `<div class="f-map__countryAgence">`;
                    temp += `<h3><a href="${link_url}">${city}</a></h3>`;
                    temp += `</div>`;
                });


                temp += `</div>`;
                temp += `</div>`;

                temp += `</li>`;

                if (index + 1 === Math.ceil(globe.datas.countries.length / 2)) {
                    temp += "</ul>";
                    temp += '<ul class="f-map__countryListe">';
                }
            })
            temp += '</ul>';

            globe.listePays.innerHTML = temp;
        }

        if (globe.datas.currentregion === "0" && globe.datas.currentcapability === "0") {
            //globe.intro.classList.remove("f-map--hidden");
            globe.listePays.classList.add("f-map--hidden");
            // if (globe.stats) {
            //     globe.stats.classList.remove("f-map--hidden");
            // }
        } else {
            //globe.intro.classList.add("f-map--hidden");
            globe.listePays.classList.remove("f-map--hidden");
            // if (globe.stats) {
            //     globe.stats.classList.add("f-map--hidden");
            // }
        }
    },

    lngLatToXYZ(longitude, latitude, radius = 1) {

        latitude = parseFloat(latitude);
        longitude = -parseFloat(longitude);

        // Convertir en radians
        // Conversion de degrés en radians
        const lon = longitude * Math.PI / 180;
        const lat = latitude * Math.PI / 180;

        // Calcul des coordonnées cartésiennes
        const x = radius * Math.cos(lat) * Math.cos(lon);
        const z = radius * Math.cos(lat) * Math.sin(lon);
        const y = radius * Math.sin(lat);

        return [x, y, z];
    },

    xyzToLngLat(x, y, z) {
        const radius = Math.sqrt(x * x + y * y + z * z); // Assuming radius = 1 if not specified

        // Longitude
        const longitude = Math.atan2(z, x);
        // Convertir en degrés et ajuster le signe pour correspondre à votre fonction originale
        const lng = -longitude * (180 / Math.PI);

        // Latitude
        const latitude = Math.asin(y / radius);
        // Convertir en degrés
        const lat = latitude * (180 / Math.PI);

        return [lng, lat];
    },

    genereCanvas(nb, isHover = false) {
        let canvas = document.createElement("canvas");
        let lineWidth = 8;
        canvas.width = 100;
        canvas.height = 100;
        let context = canvas.getContext("2d");
        context.lineWidth = lineWidth;
        context.fillStyle = "white";
        context.strokeStyle = "white";
        context.arc(canvas.width * 0.5, canvas.height * 0.5, canvas.width * 0.5 - lineWidth, 0, 2 * Math.PI);
        context.stroke();

        if (isHover) {
            context.fillStyle = "cyan";
            context.fill();
            context.fillStyle = "black";
        } else {
            context.fillStyle = "white";
        }

        if (nb > 1) {
            context.font = "bold 50px Arial";
            let text = nb;
            let textMetrics = context.measureText(text);
            let textWidth = textMetrics.width;
            let textHeight = 35;
            let centerX = canvas.width / 2;
            let centerY = canvas.height / 2;

            // Positionner le texte au centre
            context.fillText(text, centerX - textWidth / 2, centerY + textHeight / 2);
        }

        let texture = new THREE.CanvasTexture(canvas);

        return texture;
    },

    // this gives smaller circles but further tweaks are needed for markers to match city locations
    // genereCanvas(nb, isHover = false) {
    //     let canvas = document.createElement("canvas");
    //     // Reduce the internal radius to make the dot smaller
    //     let dotRadius = 15;

    //     canvas.width = 100;
    //     canvas.height = 100;
    //     let context = canvas.getContext("2d");

    //     // Start drawing the path
    //     context.beginPath();
    //     // Create a solid circle in the center
    //     context.arc(canvas.width * 0.5, canvas.height * 0.5, dotRadius, 0, 2 * Math.PI);

    //     // Use cyan for the solid dot
    //     context.fillStyle = "cyan";
    //     context.fill();

    //     // Optional: Add a white glow or border when hovered/selected
    //     if (isHover) {
    //         context.lineWidth = 10;
    //         context.strokeStyle = "white";
    //         context.stroke();
    //     }

    //     let texture = new THREE.CanvasTexture(canvas);
    //     return texture;
    // },

    decodeHtmlEntities(text) {
        const doc = new DOMParser().parseFromString(text, "text/html");
        return doc.documentElement.textContent;
    },

    genereCanvasSubpin(agency) {
        agency = Map.decodeHtmlEntities(agency);

        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        let marginLeft = 20;
        let padding = 30;
        let size = 100;

        let lineWidth = 8;

        context.font = "300 50px Lexend";
        let textMetrics = context.measureText(agency);
        let textWidth = textMetrics.width;
        let textHeight = 35;

        canvas.height = size;
        canvas.width = size + textWidth + 2 * padding + marginLeft;

        let centerY = size / 2;

        context.fillStyle = "#0C1030";
        context.fillRect(size + marginLeft, 0, textWidth + 2 * padding, size);

        context.fillStyle = "white";
        context.font = "300 50px Lexend";
        context.fillText(agency, size + marginLeft + padding, centerY + textHeight / 2);

        let texture = new THREE.CanvasTexture(canvas);

        return [texture, canvas.width / canvas.height];
    },

    transformJSON(inputJSON) {
        let output = {
            country: [],
            agences: []
        };

        // Fonction pour obtenir les coordonnées d'un pays
        const getCountryCoords = (country, region) => {
            for (let agency of inputJSON.items) {
                if (agency.countries && agency.countries[region] && agency.countries[region][country]) {
                    return {
                        name: Map.getCountryFromSlug(region, country, inputJSON.filters.regions),
                        lat: agency.countries[region][country].latitude,
                        lng: agency.countries[region][country].longitude
                    };
                }
            }
            return null;
        };

        // Collecter toutes les coordonnées des pays uniques pour toutes les régions
        let uniqueCountries = new Set();
        for (let agency of inputJSON.items) {
            if (agency.countries) {
                for (let region in agency.countries) {
                    for (let country in agency.countries[region]) {

                        if (!uniqueCountries.has(country)) {
                            uniqueCountries.add(country);
                            let coords = getCountryCoords(country, region);
                            if (coords) output.country.push(coords);
                        }
                    }
                }
            }
        }

        // Transformer les agences
        for (let agency of inputJSON.items) {
            if (agency.countries) {
                for (let region in agency.countries) {
                    for (let country in agency.countries[region]) {
                        // Assurer que les villes sont correctement collectées pour chaque pays et région

                        let citiesForCountry = [];
                        let condition = (agency.cities && agency.cities[country]);
                        if (condition) {

                            for (var i = 0; i < agency.cities[country].length; i++) {
                                agency.cities[country][i] = Map.getCityFromSlug(region, country, agency.cities[country][i], inputJSON.filters.regions);
                            }
                            citiesForCountry = [...agency.cities[country]]
                        }

                        // Création de la nouvelle agence avec les villes et le nom du pays correct
                        for (let key in agency.capabilities) {
                            agency.capabilities[key] = agency.capabilities[key].split("&amp;").join("&");

                            if (!Map.isCapabilityVisible(inputJSON, key)) {
                                delete agency.capabilities[key];
                            }
                        }
                        let newAgency = {
                            name: agency.title,
                            link: agency.link,
                            city: citiesForCountry,
                            country: Map.getCountryFromSlug(region, country, inputJSON.filters.regions),
                            region: Map.getRegionFromSlug(region, inputJSON.filters.regions),
                            capabilities: Object.values(agency.capabilities)
                        };
                        output.agences.push(newAgency);
                    }
                }
            }
        }

        return output;
    },

    isCapabilityVisible(json, cap) {
        if (json?.filters?.capabilities?.[cap]) {
            return true;
        }
        return false;
    },

    getRegionFromSlug(slug, regions) {
        return regions[slug].label
    },

    getCountryFromSlug(slug, subslug, regions) {
        return regions[slug].countries[subslug].label;
    },

    getCityFromSlug(slug, subslug, subslug2, regions) {
        return regions[slug].countries[subslug].cities[subslug2].label;
    },

    getCenterPosition(countries) {
        let nbCountries = countries.length;
        let lng = 0;
        let lat = 0;
        countries.forEach(coun => {
            lng += parseFloat(coun.lng);
            lat += parseFloat(coun.lat);
        })
        lng = lng / nbCountries;
        lat = lat / nbCountries;

        return { lng, lat };
    },

    getRegion(globe, country) {
        let result = globe.datas.countries.filter(item => item.name.toLowerCase() === country.toLowerCase());
        if (result.length > 0) {
            return result[0].region.toLowerCase();
        }
        return null;
    }
};

export default Map;